import styled from 'styled-components'

interface ListProps<T> {
  dataSource: T[]
  renderItem: (item: T, index: number) => React.ReactNode
  emptyText?: string | React.ReactNode
}
/**
 * @deprecated 더이상 사용하지 않음
 */
export const List = <T,>({ dataSource, renderItem, emptyText }: ListProps<T>) => {
  const showsEmptyText = emptyText && dataSource.length === 0

  return (
    <StyledListDiv>
      <StyledSpinNestedDiv>
        <StyledSpinContainerDiv>
          {showsEmptyText ? <>{emptyText}</> : <StyledListUl>{dataSource.map(renderItem)}</StyledListUl>}
        </StyledSpinContainerDiv>
      </StyledSpinNestedDiv>
    </StyledListDiv>
  )
}

const StyledListDiv = styled.div``
const StyledSpinNestedDiv = styled.div``
const StyledSpinContainerDiv = styled.div``
const StyledListUl = styled.ul``
